export var Browsers = {
  rO: "Chrome",
  eO: "Edge",
  oO: "Opera",
  xg: "Safari",
  OO: "Firefox"
};
export var OperatingSystems = {
  Pg: "Android",
  co: "iOS",
  Og: "Mac",
  Bg: "Windows"
};